class Alert{static alert(){}}export default Alert;